module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/build/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/build/node_modules/source-map-loader/dist/cjs.js!/build/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}